import ComposeBottomActionBar, {
    ComposeBottomActionBarProps,
    ComposeBottomActionBarHandle,
} from './ComposeBottomActionBar';
import ComposeBottomEditorSendHost from './ComposeBottomEditorSendHost';
import ComposeBottomSendDiscard, {
    ComposeBottomSendDiscardHandle,
} from './ComposeBottomSendDiscard';
import ComposeComponentProps from './ComposeComponentProps';
import { aFPCreateAttachmentHandler } from '../utils/createAttachmentHandler';
import { focusToEditor } from 'owa-editor';
import getSensitivitySubMenu from '../utils/getSensitivitySubMenu';
import { getMailboxInfoFromViewState } from '../utils/getMailboxInfoFromViewState';
import logAttachButtonClickedDatapoint from '../utils/logAttachButtonClickedDatapoint';
import { lazyLogAttachMenuData, lazyLogAttachMenuDataOnClose } from 'owa-attachment-suggestions';
import { observer } from 'mobx-react-lite';
import { DirectionalHint } from 'office-ui-fabric-react/lib/common/DirectionalHint';
import { IContextualMenuProps } from 'office-ui-fabric-react/lib/ContextualMenu';
import { IconType } from 'office-ui-fabric-react/lib/Icon';
import { populateCommandBarWithAddins } from 'owa-addins-surface-actions';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import { attachmentMultiMenuEntry } from 'owa-attachment-multi-menu-actions';
import { CreateAttachmentsProperties } from 'owa-attachment-well-data';
import { preloadUploadFolder, UploadFolderMailboxType } from 'owa-attachments-upload-folder';
import { getPackageBaseUrl } from 'owa-config';
import { ComposeUniqueState } from 'owa-attachment-filepicker';
import { ControlIcons } from 'owa-control-icons';
import { getDictationStore, loadSetDictationLanguageMenu } from 'owa-editor-dictation-plugin';
import { getBottomDockingHeight, updateDockingHeight } from 'owa-editor-docking-plugin';
import { LazyComposeRibbon } from 'owa-compose-ribbon';
import { RIBBON_OPENED_SOURCE } from 'owa-expressions-store/lib/store/schema/ExpressionPickerOpenedSource';
import expressionStore from 'owa-expressions-store/lib/store/expressionStore';
import { lazyToggleExpressionPane } from 'owa-expressions-view';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isGroupTableSelected } from 'owa-group-utils';
import { useKeydownHandler } from 'owa-hotkeys';
import { addInitialAction } from 'owa-initial-actions';
import loc from 'owa-localize';
import { composeSetPermissionDropDown } from 'owa-locstrings/lib/strings/composeprotectbutton.locstring.json';
import { formattingOptionsTooltip } from 'owa-locstrings/lib/strings/formattingoptionstooltip.locstring.json';
import { highImportanceMenuText } from 'owa-locstrings/lib/strings/highimportancemenutext.locstring.json';
import { lowImportanceMenuText } from 'owa-locstrings/lib/strings/lowimportancemenutext.locstring.json';
import { normalImportanceMenuText } from 'owa-locstrings/lib/strings/normalimportancemenutext.locstring.json';
import { sensitivityMenuText } from 'owa-locstrings/lib/strings/sensitivitymenutext.locstring.json';
import { showFrom } from 'owa-locstrings/lib/strings/showfrom.locstring.json';
import { switchToPlainTextMenuItem } from 'owa-locstrings/lib/strings/switchtoplaintextmenuitem.locstring.json';
import { lazyOpenFilePickerFromSmartDoc } from 'owa-mail-smart-doc/lib/filePickerIndex';
import { SmartDocOption } from 'owa-mail-smart-pill-features';
import { openLocalFilePicker, openCloudFilePicker } from '../utils/openFilePicker';
import shouldAddinsPopulate from 'owa-mail-addins/lib/utils/shouldAddinsPopulate';
import { protectionStore } from 'owa-mail-protection/lib/store/protectionStore';
import isCLPEnabled from 'owa-mail-protection/lib/utils/clp/isCLPEnabled';
import { loadAttachmentSuggestions } from 'owa-mail-compose-actions';
import getCurrentFromAddress from 'owa-mail-compose-actions/lib/utils/getFromAddressFromRecipientWell';
import getSubMenuPropsForProofing from 'owa-editor-proofing-plugin/lib/utils/getSubMenuPropsForProofing';
import { lazyDisableProofing } from 'owa-editor-proofing-plugin';
import discardCompose from 'owa-mail-compose-actions/lib/actions/discardCompose';
import getComposeUniqueState from 'owa-mail-compose-actions/lib/utils/getComposeUniqueState';
import protectMessageAndRemoveAddin from 'owa-mail-compose-actions/lib/utils/protectMessageAndRemoveAddin';
import setImportance from 'owa-mail-compose-actions/lib/actions/setImportance';
import setIsDarkMode from 'owa-mail-compose-actions/lib/actions/setIsDarkMode';
import switchBodytype from 'owa-mail-compose-actions/lib/actions/switchBodyType';
import toggleFrom from 'owa-mail-compose-actions/lib/actions/toggleFrom';
import toggleRibbon from 'owa-mail-compose-actions/lib/actions/toggleRibbon';
import trySaveMessage from 'owa-mail-compose-actions/lib/actions/trySaveMessage';
import isPublicFolderComposeViewState from 'owa-mail-compose-store/lib/utils/isPublicFolderComposeViewState';
import handleOnSend from 'owa-mail-compose-actions/lib/utils/handleOnSend';
import isComposeDarkModeEnabled from 'owa-mail-compose-actions/lib/utils/isComposeDarkModeEnabled';
import shouldDisableEncryptionButton from 'owa-mail-protection/lib/utils/rms/shouldDisableEncryptionButton';
import { SharedFolderComposeViewState, UIEnabledState } from 'owa-mail-compose-store';
import { getCommands } from 'owa-mail-hotkeys/lib/utils/MailModuleHotKeys';
import { showMessageOptionsDialog } from 'owa-mail-message-options-view';
import { getEditorSupport } from 'owa-mail-preferred-editor/lib/getEditorSupport';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import { ComposeActionKey } from 'owa-outlook-service-options';
import ImportanceType from 'owa-service/lib/contract/ImportanceType';
import Item from 'owa-service/lib/contract/Item';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import isSmimeEnabledInViewState from 'owa-smime/lib/utils/isSmimeEnabledInViewState';
import { getPaletteAsRawColors } from 'owa-theme';
import { DarkModeContext } from 'owa-theme';
import { isBrowserIE } from 'owa-user-agent/lib/userAgent';
import { resolve as urlResolve } from 'url';
import * as React from 'react';
import { isBrowserChrome, isBrowserFirefox, isBrowserEdge } from 'owa-user-agent/lib/userAgent';
import { lazyCloseChecker, lazyOpenChecker } from 'owa-editor-acc-checker-plugin';
import insertSignature from 'owa-mail-compose-actions/lib/utils/insertSignature';
import {
    getEncryptionDropDownSubMenu,
    getIRMTemplatesDropDown,
} from '../utils/getEncryptionDropDownSubMenu';
import {
    formattingOptionsTooltipHide,
    startDictationToolTip,
    stopDictationToolTip,
    toggleDarkComposeOff,
    toggleDarkComposeOn,
} from './ComposeBottom.locstring.json';
import { LazyRecentAttachmentPillContainer } from 'owa-recent-attachment-pills';
import {
    encryptMenuText,
    encryptDisableForwardingMenuText,
    hideFrom,
    switchToHTMLMenuItem,
} from '../strings.locstring.json';
import getAttachmentCommandItems, {
    getDefaultButtonsList,
    getSmimeAttachButtonsList,
} from '../utils/getAttachmentCommandItems';
import {
    lazyInitializeAttachmentFilePicker,
    AttachmentLocalComputerFilePicker,
    CreateAttachmentHandlerParams,
    IAttachmentLocalComputerFilePicker,
    FilePickerAction,
    FileSelectionFilter,
} from 'owa-attachment-filepicker';
import {
    getComposeStaticActions,
    getComposeActionDisplayName,
    getComposeActionIconName,
    SurfaceActionItem,
    StaticAction,
    logUserAction,
} from 'owa-surface-actions';
import {
    getOptionsForFeature,
    OwsOptionsFeatureType,
    SurfaceActionsOptions,
} from 'owa-outlook-service-options';
import {
    ENCRYPT_GUID,
    ENCRYPT_DNF_GUID,
    IRM_DEFAULT_GUID,
} from 'owa-mail-protection/lib/store/schema/rms/EncryptionGUID';
import { getGuid } from 'owa-guid';
import { getAttachmentSuggestionsTraceId } from '../utils/getAttachmentCommandItems';
import ProjectionContext from 'owa-popout-v2/lib/context/ProjectionContext';
import { lazyToggleDictation } from 'owa-editor-dictation-plugin';
import isApprovalResponse from '../utils/isApprovalResponse';

const styles = require('./ComposeBottom.scss');
const classNames = require('classnames/bind').bind(styles);
const dictationRecordingSVG = urlResolve(
    getPackageBaseUrl(),
    'resources/images/surfaceActions/dictationRecording.svg'
);
const dictateSVG = urlResolve(getPackageBaseUrl(), 'resources/images/surfaceActions/dictate.svg');
const DISABLE_PROOFING_BODY_LENGTH_THESHOLD = 80000;

export interface ComposeBottomProps extends ComposeComponentProps {
    isHidden: boolean;
}

export interface ComposeBottomHandle {
    resize(): void;
}

function useInitialActions(
    { initialActions, viewState, isHidden }: ComposeBottomProps,
    attachmentLocalComputerFilePicker: React.RefObject<IAttachmentLocalComputerFilePicker>,
    attachmentLocalComputerToCloudFilePicker: React.RefObject<IAttachmentLocalComputerFilePicker>,
    targetWindow: Window
) {
    React.useEffect(() => {
        const checkSmartDocOptionAndOpenFilePicker = (option: SmartDocOption) => {
            // If another composeBottom is triggered by Dock (happens on IE/Safari),
            // do not open file pickers to prevent opening twice.
            if (isHidden) {
                return;
            }
            if (
                option === SmartDocOption.LocalFiles ||
                option === SmartDocOption.CloudFiles ||
                option === SmartDocOption.UploadAndShare
            ) {
                // open the file picker if triggered by smart doc menu buttons
                lazyOpenFilePickerFromSmartDoc.import().then(openFilePickerFromSmartDoc =>
                    openFilePickerFromSmartDoc(
                        openLocalFilePicker,
                        openCloudFilePicker,
                        () => attachmentLocalComputerFilePicker.current || null,
                        () => attachmentLocalComputerToCloudFilePicker.current || null,
                        viewState,
                        targetWindow
                    )
                );
            }
        };

        addInitialAction(initialActions, async () => {
            const initializeAttachmentFilePicker = await lazyInitializeAttachmentFilePicker.import();
            initializeAttachmentFilePicker();

            checkSmartDocOptionAndOpenFilePicker(viewState?.smartPillViewState?.smartDocOption);
        });
        addInitialAction(initialActions, async () => {
            const attachmentWell = viewState.attachmentWell;
            // we preload the default folder which is used to upload to the
            // onedrive in the upload and share scenario
            if (isGroupTableSelected() && attachmentWell && attachmentWell.groupId) {
                preloadUploadFolder(
                    viewState.attachmentWell.groupId,
                    UploadFolderMailboxType.Group
                );
            } else {
                preloadUploadFolder();
            }
        });
    }, []);
}

function useCommandBarProps(
    { viewState }: ComposeBottomProps,
    attachmentInlineFilePicker: React.RefObject<IAttachmentLocalComputerFilePicker>,
    attachmentLocalComputerFilePicker: React.RefObject<IAttachmentLocalComputerFilePicker>,
    attachmentLocalComputerToCloudFilePicker: React.RefObject<IAttachmentLocalComputerFilePicker>
) {
    const targetWindow = React.useContext(ProjectionContext);
    const isDarkMode = React.useContext(DarkModeContext);
    const suggestedAttachmentsLogicalId = React.useRef(getGuid());
    const suggestedAttachmentsTraceId = React.useRef<string>();
    const attachMenuOpenTime = React.useRef<number>();

    const getItem = React.useCallback((): Item => {
        // Return the item if it is available
        const { itemId } = viewState;
        if (!itemId) {
            return null;
        }

        return getMailStore().items.get(itemId.Id);
    }, [viewState]);

    const disableProofing = React.useCallback(() => {
        lazyDisableProofing.import().then(disableProofing => disableProofing(viewState));
    }, [viewState]);

    const onInsertSignature = React.useCallback(
        (
            event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
            item?: SurfaceActionItem
        ) => {
            logCSAUserAction('InsertSignature', item);
            insertSignature(viewState);
        },
        [viewState]
    );

    const onOpenInlineFilePicker = React.useCallback(
        (
            event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
            item?: SurfaceActionItem
        ) => {
            logCSAUserAction('AddInlineImage', item);
            if (!viewState.itemId) {
                trySaveMessage(viewState);
            }

            attachmentInlineFilePicker.current?.click();
        },
        [viewState]
    );

    const onSetImportance = React.useCallback(
        (importance: ImportanceType, item?: SurfaceActionItem) => {
            logCSAUserAction('SetImportance', item, importance);
            setImportance(viewState, importance);
            focusToEditor(viewState);
        },
        [viewState]
    );

    const onSwitchBodyType = React.useCallback(
        (
            event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
            item?: SurfaceActionItem
        ) => {
            const suffix = viewState.bodyType == 'HTML' ? 'Plain' : 'HTML'; // Reversed to log the type being set.
            logCSAUserAction('SwitchBodyType', item, suffix);
            switchBodytype(viewState, targetWindow);
        },
        [viewState, targetWindow]
    );

    const onToggleAccChecker = React.useCallback(
        (
            event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
            item?: SurfaceActionItem
        ) => {
            const { accChecker } = viewState;
            let dataPointSuffix = '';
            if (accChecker.isOpen) {
                dataPointSuffix = 'Close';
                lazyCloseChecker
                    .import()
                    .then(closeChecker => closeChecker(accChecker, targetWindow));
            } else {
                dataPointSuffix = 'Open';
                lazyOpenChecker
                    .import()
                    .then(openChecker => openChecker(accChecker, viewState, targetWindow));
            }

            logCSAUserAction('AccChecker', item, dataPointSuffix);
        },
        [viewState, targetWindow]
    );

    const onToggleDarkCompose = React.useCallback(
        (
            event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
            item?: SurfaceActionItem
        ) => {
            setIsDarkMode(viewState, !viewState.isDarkMode);
        },
        [viewState]
    );

    const onToggleDictation = React.useCallback(
        (
            event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
            item?: SurfaceActionItem
        ) => {
            // telemetry
            logCSAUserAction('ToggleDictation', item);

            lazyToggleDictation.import().then(toggleDictation => toggleDictation(viewState));

            focusToEditor(viewState);
        },
        [viewState]
    );

    const onToggleExpressionPicker = React.useCallback(
        (
            event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
            item?: SurfaceActionItem
        ) => {
            const isExpressionPaneOpen = expressionStore.expressionPickerViewState?.isOpen;

            lazyToggleExpressionPane.import().then(toggleExpressionPane => {
                toggleExpressionPane(
                    !isExpressionPaneOpen /* shouldShow */,
                    true /* useFlexPane */,
                    RIBBON_OPENED_SOURCE,
                    viewState
                );
            });

            logCSAUserAction('AddEmoji', item, isExpressionPaneOpen ? 'Close' : 'Open');
        },
        [viewState]
    );

    const onToggleRibbon = React.useCallback(
        (
            event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
            item?: SurfaceActionItem
        ) => {
            toggleRibbon(viewState);

            logCSAUserAction('ToggleRibbon', item, viewState.isRibbonShown ? 'On' : 'Off');

            const { docking, isInlineCompose, isRibbonShown } = viewState;
            updateDockingHeight(docking, getBottomDockingHeight(isRibbonShown, isInlineCompose));

            focusToEditor(viewState);
        },
        [viewState]
    );

    const tryCreateStaticActionCommandBarItem = React.useCallback(
        (
            action: StaticAction,
            isDarkMode: boolean,
            shouldForceDisable: boolean
        ): SurfaceActionItem => {
            if (action.hideInGroup && isGroupTableSelected()) {
                return null;
            }
            const isPlainText = viewState.bodyType != 'HTML';
            const actionKey = action.key as ComposeActionKey;
            let displayName = getComposeActionDisplayName(actionKey);
            let { iconName, fallbackIconName, isImage } = getComposeActionIconName(actionKey);
            let isDisabled = false;
            let canCheck = false;
            let isChecked = false;
            let clickHandler: (
                ev?: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>
            ) => boolean | void;
            let subMenuProps: IContextualMenuProps;
            let customClassName: string;
            let customRender: (className: string) => JSX.Element;
            const referenceAttachmentsSupported =
                getComposeUniqueState(viewState) === ComposeUniqueState.None;
            const { clpLabels } = protectionStore;
            const isPublicFolderPostAction = isPublicFolderComposeViewState(viewState);
            const userConfiguration = getUserConfiguration();
            const isSmimeCompose = isSmimeEnabledInViewState(viewState.smimeViewState);
            const quotedBodyLength = !viewState.isInlineCompose ? viewState.quotedBody?.length : 0;

            switch (actionKey) {
                case 'AddAttachment':
                    isDisabled =
                        (!userConfiguration.AttachmentPolicy.ClassicAttachmentsEnabled &&
                            !userConfiguration.AttachmentPolicy.ReferenceAttachmentsEnabled) ||
                        isApprovalResponse(viewState);
                    subMenuProps = {
                        items: getAttachmentCommandItems(
                            () => attachmentLocalComputerFilePicker.current || null,
                            () => attachmentLocalComputerToCloudFilePicker.current || null,
                            viewState,
                            suggestedAttachmentsLogicalId.current,
                            suggestedAttachmentsTraceId.current,
                            () => {
                                suggestedAttachmentsTraceId.current = null;
                            },
                            attachMenuOpenTime.current,
                            targetWindow
                        ),
                        onMenuOpened: () => {
                            attachMenuOpenTime.current = new Date().getTime();
                            if (!isSmimeCompose && !isPlainText) {
                                loadAttachmentSuggestions(viewState);
                            }

                            logAttachButtonClickedDatapoint(viewState.referenceItemId?.Id);

                            const logicalId = suggestedAttachmentsLogicalId.current;
                            const newLogicalId = getGuid();
                            suggestedAttachmentsLogicalId.current = newLogicalId;

                            // Log info about the buttons shown in the menu.
                            lazyLogAttachMenuData.importAndExecute(
                                viewState.referenceItemId,
                                (isSmimeCompose
                                    ? getSmimeAttachButtonsList()
                                    : getDefaultButtonsList(!referenceAttachmentsSupported)
                                ).join(','),
                                logicalId,
                                newLogicalId
                            );

                            suggestedAttachmentsTraceId.current = getAttachmentSuggestionsTraceId(
                                viewState.referenceItemId
                            );
                        },
                        onMenuDismissed: () => {
                            // Log that the menu has been dismissed.
                            lazyLogAttachMenuDataOnClose.importAndExecute(
                                viewState.referenceItemId
                            );

                            suggestedAttachmentsTraceId.current = null;
                        },
                        directionalHint: DirectionalHint.topLeftEdge,
                        directionalHintFixed: false,
                    };
                    customClassName = styles.attachmentCommandBarButtonWithSubMenu;
                    break;
                case 'AddInlineImage':
                    clickHandler = onOpenInlineFilePicker;
                    isDisabled = isPlainText || isApprovalResponse(viewState);
                    break;
                case 'AddEmoji':
                    clickHandler = onToggleExpressionPicker;
                    isDisabled = isPlainText;
                    canCheck = true;
                    isChecked = expressionStore.expressionPickerViewState?.isOpen;
                    break;
                case 'ToggleDarkCompose':
                    if (isComposeDarkModeEnabled()) {
                        displayName = isDarkMode
                            ? loc(toggleDarkComposeOff)
                            : loc(toggleDarkComposeOn);
                        iconName = isDarkMode ? ControlIcons.Sunny : ControlIcons.ClearNight;
                        clickHandler = onToggleDarkCompose;
                    }
                    break;
                case 'ToggleDictation':
                    clickHandler = onToggleDictation;
                    isDisabled = isPlainText;
                    canCheck = true;
                    const isDictationOn = getDictationStore().isDictationOn;
                    iconName = isDictationOn ? dictationRecordingSVG : dictateSVG;
                    fallbackIconName = iconName;
                    isImage = true;
                    displayName = isDictationOn
                        ? loc(stopDictationToolTip)
                        : loc(startDictationToolTip);
                    break;
                case 'SetDictationLanguage':
                    isDisabled = isPlainText;
                    subMenuProps = {
                        items: getDictationStore().languagePickerDropDown,
                        onMenuOpened: () => {
                            loadSetDictationLanguageMenu();
                        },
                    };
                    customClassName = styles.commandBarButtonWithSubMenu;
                    break;
                case 'ToggleRibbon':
                    isDisabled = isPlainText;
                    displayName = viewState.isRibbonShown
                        ? loc(formattingOptionsTooltipHide)
                        : loc(formattingOptionsTooltip); // Override default string based on actual state
                    clickHandler = onToggleRibbon;
                    canCheck = true;
                    isChecked = viewState.isRibbonShown;
                    break;
                case 'ProofingOptions':
                    isDisabled = quotedBodyLength >= DISABLE_PROOFING_BODY_LENGTH_THESHOLD;
                    if (isDisabled) {
                        disableProofing();
                    } else {
                        subMenuProps = getSubMenuPropsForProofing(viewState);
                    }
                    customClassName = styles.proofingCommandBarButtonWithSubMenu;
                    break;
                case 'SensitivityMenu':
                    displayName = loc(sensitivityMenuText);
                    if (isCLPEnabled()) {
                        subMenuProps = {
                            items: getSensitivitySubMenu(
                                clpLabels,
                                viewState,
                                isSmimeCompose,
                                targetWindow
                            ),
                        };
                    }
                    customClassName = styles.commandBarButtonWithSubMenu;
                    isDisabled = !isCLPEnabled();
                    break;
                case 'ProtectMessage':
                    // We bifurcate here based on consumer status, changing from a nested menu (consumer)
                    // To adding an info bar with a unique UI for changing protection (enterprise)
                    // This logic should match that in ComposeCommandingBar.tsx
                    const { protectionViewState } = viewState;
                    if (isConsumer()) {
                        subMenuProps = {
                            items: [
                                {
                                    name: loc(encryptMenuText),
                                    key: 'Encrypt',
                                    onClick: () => {
                                        protectMessageAndRemoveAddin(viewState, ENCRYPT_GUID);
                                    },
                                    disabled: shouldDisableEncryptionButton(
                                        protectionViewState,
                                        ENCRYPT_GUID
                                    ),
                                },
                                {
                                    name: loc(encryptDisableForwardingMenuText),
                                    key: 'EncryptDNF',
                                    onClick: () => {
                                        protectMessageAndRemoveAddin(viewState, ENCRYPT_DNF_GUID);
                                    },
                                    disabled: shouldDisableEncryptionButton(
                                        protectionViewState,
                                        ENCRYPT_DNF_GUID
                                    ),
                                },
                            ],
                        };
                    } else {
                        // The encrypt drop down should be shown if CLP is enabled
                        // and user's CLP Label list is not empty
                        // else
                        // Show the original encryption experience.
                        if (isCLPEnabled()) {
                            subMenuProps = getEncryptionDropDownSubMenu(viewState, [
                                ENCRYPT_GUID,
                                ENCRYPT_DNF_GUID,
                            ]);
                        } else {
                            const { RmsV2UIEnabled } = getUserConfiguration();
                            if (RmsV2UIEnabled) {
                                clickHandler = () => {
                                    protectMessageAndRemoveAddin(viewState, IRM_DEFAULT_GUID);
                                };
                            } else {
                                displayName = loc(composeSetPermissionDropDown);
                                subMenuProps = getIRMTemplatesDropDown(viewState);
                            }
                        }
                    }
                    isDisabled = shouldDisableEncryptionButton(protectionViewState);
                    customClassName = styles.commandBarButtonWithSubMenu;
                    break;
                case 'SaveDraft':
                    if (isPublicFolderPostAction) {
                        break;
                    }
                    clickHandler = (
                        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
                        item?: SurfaceActionItem
                    ) => {
                        logCSAUserAction(actionKey, item);
                        trySaveMessage(viewState);
                        focusToEditor(viewState);
                    };
                    break;
                case 'InsertSignature':
                    if (isPublicFolderPostAction) {
                        break;
                    }
                    clickHandler = onInsertSignature;
                    break;
                case 'ShowFrom':
                    isDisabled = viewState.fromViewState.isFromReadOnly || isSmimeCompose;
                    const isFromShown = viewState.fromViewState.isFromShown;
                    displayName = !isFromShown ? loc(showFrom) : loc(hideFrom); // Override default string based on actual state
                    clickHandler = (
                        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
                        item?: SurfaceActionItem
                    ) => {
                        logCSAUserAction(actionKey, item, isFromShown ? 'Hide' : 'Show');
                        toggleFrom(viewState);
                        focusToEditor(viewState);
                    };
                    break;
                case 'ShowMessageOptions':
                    if (isPublicFolderPostAction) {
                        break;
                    }
                    clickHandler = (
                        event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
                        item?: SurfaceActionItem
                    ) => {
                        showMessageOptionsDialog(viewState, targetWindow);
                    };
                    break;
                case 'SetImportance':
                    subMenuProps = {
                        items: [
                            {
                                name: loc(highImportanceMenuText),
                                key: 'High',
                                onClick: (
                                    event:
                                        | React.KeyboardEvent<HTMLElement>
                                        | React.MouseEvent<HTMLElement>,
                                    item?: SurfaceActionItem
                                ) => {
                                    onSetImportance('High', item);
                                },
                                canCheck: true,
                                checked: viewState.importance === 'High',
                            },
                            {
                                name: loc(normalImportanceMenuText),
                                key: 'Normal',
                                onClick: (
                                    event:
                                        | React.KeyboardEvent<HTMLElement>
                                        | React.MouseEvent<HTMLElement>,
                                    item?: SurfaceActionItem
                                ) => {
                                    onSetImportance('Normal', item);
                                },
                                canCheck: true,
                                checked: viewState.importance === 'Normal',
                            },
                            {
                                name: loc(lowImportanceMenuText),
                                key: 'Low',
                                onClick: (
                                    event:
                                        | React.KeyboardEvent<HTMLElement>
                                        | React.MouseEvent<HTMLElement>,
                                    item?: SurfaceActionItem
                                ) => {
                                    onSetImportance('Low', item);
                                },
                                canCheck: true,
                                checked: viewState.importance === 'Low',
                            },
                        ],
                    };
                    customClassName = styles.commandBarButtonWithSubMenu;
                    break;
                case 'SwitchBodyType':
                    if (!viewState.isInlineCompose) {
                        displayName = isPlainText
                            ? loc(switchToHTMLMenuItem)
                            : loc(switchToPlainTextMenuItem);
                        clickHandler = onSwitchBodyType;
                    }
                    break;
                case 'AccChecker':
                    isDisabled = isPlainText;
                    canCheck = true;
                    isChecked = viewState.accChecker?.isOpen;
                    clickHandler = onToggleAccChecker;
                    break;
            }

            if (clickHandler || subMenuProps) {
                const iconType = isImage ? IconType.image : IconType.default;
                const imageProps = isImage
                    ? {
                          shouldFadeIn: false,
                          src: fallbackIconName,
                          className: styles.commandBarImage,
                      }
                    : null;
                const iconClassName = classNames(styles.commandBarIcon, {
                    isImage: isImage,
                    isIE: isBrowserIE(),
                });
                return {
                    key: actionKey,
                    name: displayName,
                    iconProps: {
                        iconName: isImage ? null : iconName,
                        iconType: iconType,
                        imageProps: imageProps,
                        className: iconClassName,
                    },
                    disabled: isDisabled || shouldForceDisable,
                    canCheck: canCheck,
                    checked: isChecked,
                    onClick: clickHandler,
                    subMenuProps: subMenuProps,
                    className: customClassName,
                    onRender: customRender,
                    iconOnly: true,
                    ariaLabel: displayName,
                };
            } else {
                return null;
            }
        },
        [
            disableProofing,
            onInsertSignature,
            onOpenInlineFilePicker,
            onSetImportance,
            onSwitchBodyType,
            onToggleAccChecker,
            onToggleDarkCompose,
            onToggleDictation,
            onToggleExpressionPicker,
            onToggleRibbon,

            targetWindow,
            viewState,
            viewState.accChecker?.isOpen,
            viewState.bodyType,
            viewState.fromViewState.isFromReadOnly,
            viewState.fromViewState.isFromShown,
            viewState.importance,
            viewState.isInlineCompose,
            viewState.isInlineCompose,
            viewState.isRibbonShown,
            viewState.protectionViewState,
            viewState.quotedBody?.length,
            viewState.referenceItemId,
            viewState.smimeViewState,
        ]
    );

    const commandBarProps = ((): ComposeBottomActionBarProps => {
        const surfaceItems: SurfaceActionItem[] = [];
        const overflowItems: SurfaceActionItem[] = [];
        const disabled = viewState.uiEnabledState === UIEnabledState.AllDisabled;

        const staticActions = getComposeStaticActions();

        // Normally, this would live in getStaticActions, but it's here instead.
        // We don't want the dark toggle to show up in options and be changable.
        // This pattern should not be repeated.
        if (isComposeDarkModeEnabled() && isFeatureEnabled('cmp-darkModeToggle')) {
            staticActions.push({ key: 'ToggleDarkCompose', hideInGroup: false });
        }

        // Dictation: we want to keep "SetDictationLanguage" in the overflow always
        // So this will not show up in the settings menu
        if (
            (isBrowserEdge() || isBrowserFirefox() || isBrowserChrome()) &&
            isFeatureEnabled('cmp-dictation')
        ) {
            staticActions.push({ key: 'SetDictationLanguage', hideInGroup: false });
        }

        const surfaceActionsOptions = getOptionsForFeature<SurfaceActionsOptions>(
            OwsOptionsFeatureType.SurfaceActions
        );

        staticActions.forEach(action => {
            const commandBarItem = tryCreateStaticActionCommandBarItem(
                action,
                isDarkMode,
                disabled
            );
            if (commandBarItem) {
                let shouldDisplayInOverflow: boolean =
                    (action.key as ComposeActionKey) == 'SetDictationLanguage';
                // If we were able to create a command bar item, check if the user has it in their surface actions.
                if (
                    (!shouldDisplayInOverflow &&
                        surfaceActionsOptions.composeSurfaceActions.indexOf(
                            action.key as ComposeActionKey
                        ) >= 0) ||
                    (action.key as ComposeActionKey) == 'ToggleDarkCompose'
                ) {
                    // If they do, push it to the surface.
                    commandBarItem.isPinned = true;
                    if (commandBarItem.subMenuProps) {
                        commandBarItem.subMenuProps.items.forEach(subItem => {
                            subItem.isPinned = true;
                        });
                    }
                    surfaceItems.push(commandBarItem);
                } else {
                    // If they don't, push it to the overflow and override any custom rendering.
                    commandBarItem.onRender = null;
                    commandBarItem.renderedInOverflow = true;
                    if (commandBarItem.subMenuProps) {
                        commandBarItem.subMenuProps.items.forEach(subItem => {
                            subItem.renderedInOverflow = true;
                        });
                    }
                    overflowItems.push(commandBarItem);
                }
            }
        });

        // Push add-ins to the command bar if the add-ins flight is on and we're not in groups.
        if (shouldAddinsPopulate(viewState)) {
            populateCommandBarWithAddins(
                ExtensibilityModeEnum.MessageCompose,
                getItem(),
                viewState.composeId,
                surfaceActionsOptions.composeSurfaceAddins,
                surfaceItems,
                overflowItems,
                false /* isEndAligned */,
                0,
                styles.addinCommandBarItem /* className */,
                null /* alwaysAddToOverflow */,
                (viewState as SharedFolderComposeViewState).isInSharedFolder,
                disabled
            );
        }

        return { items: surfaceItems, overflowItems: overflowItems };
    })();

    return commandBarProps;
}

export default observer(
    function ComposeBottom(props: ComposeBottomProps, ref: React.Ref<ComposeBottomHandle>) {
        const { viewState, isHidden } = props;

        React.useImperativeHandle(
            ref,
            () => ({
                resize() {
                    // Resize the sendDiscard first so that the actionBar has an accurate
                    // measure of its available space
                    sendDiscard.current?.resize();
                    actionBar.current?.resize();
                },
            }),
            []
        );

        const attachmentInlineFilePicker = React.useRef<IAttachmentLocalComputerFilePicker>();
        const attachmentLocalComputerFilePicker = React.useRef<
            IAttachmentLocalComputerFilePicker
        >();
        const attachmentLocalComputerToCloudFilePicker = React.useRef<
            IAttachmentLocalComputerFilePicker
        >();
        const sendDiscard = React.useRef<ComposeBottomSendDiscardHandle>();
        const actionBar = React.useRef<ComposeBottomActionBarHandle>();
        const containerRef = React.useRef<HTMLDivElement>();

        const targetWindow = React.useContext(ProjectionContext);
        const isDarkMode = React.useContext(DarkModeContext);
        const commandBarProps = useCommandBarProps(
            props,
            attachmentInlineFilePicker,
            attachmentLocalComputerFilePicker,
            attachmentLocalComputerToCloudFilePicker
        );

        useInitialActions(
            props,
            attachmentLocalComputerFilePicker,
            attachmentLocalComputerToCloudFilePicker,
            targetWindow
        );

        /**
         * Call onSend from props, or send compose directly if unset in props
         */
        const sendMessage = React.useCallback(() => {
            handleOnSend(viewState, targetWindow);
        }, [viewState, targetWindow]);
        useKeydownHandler(containerRef, getCommands().sendMail, sendMessage);

        /**
         * Call onDiscard from props, or discard compose directly if unset in props
         */
        const discardDraft = React.useCallback(() => {
            discardCompose(viewState, targetWindow);
        }, [viewState, targetWindow]);
        useKeydownHandler(containerRef, getCommands().discardDraft, discardDraft, {
            allowHotkeyOnTextFields: true,
        });

        const saveDraft = React.useCallback(() => {
            trySaveMessage(viewState);
        }, [viewState]);
        useKeydownHandler(containerRef, getCommands().saveDraft, saveDraft);

        const createAttachmentHandler = React.useCallback(
            (params: CreateAttachmentHandlerParams) => {
                const baseProperties = { isInline: params.isInline, isHiddenInline: false };
                const properties: CreateAttachmentsProperties = params.shouldShare
                    ? { ...baseProperties, shouldShare: true }
                    : { ...baseProperties, shouldShare: false };

                aFPCreateAttachmentHandler(
                    params.files,
                    viewState,
                    properties,
                    params.dataProviderType
                );
            },
            [viewState]
        );

        const disabled = viewState.uiEnabledState === UIEnabledState.AllDisabled;
        const {
            isInlineCompose,
            isRibbonShown,
            ribbon,
            docking: { useStickyDocking },
        } = viewState;
        const handlerForAttachFromComputer = attachmentMultiMenuEntry.computer.getCreateAttachmentHandler(
            viewState.attachmentWell,
            (files, properties, dataProvider) =>
                aFPCreateAttachmentHandler(files, viewState, properties, dataProvider),
            getComposeUniqueState(viewState)
        );

        const handlerForUploadAndShareFromCloud = attachmentMultiMenuEntry.uploadAndShareFromCloud.getCreateAttachmentHandler(
            viewState.attachmentWell,
            (files, properties, dataProvider) =>
                aFPCreateAttachmentHandler(files, viewState, properties, dataProvider),
            getComposeUniqueState(viewState)
        );

        const bottomDockingStyle = isDarkMode
            ? null
            : {
                  // This spacer is supposed to use theme colors.
                  //
                  // Since the Compose wrapper is already in a reset context,
                  // set these colors directly from the raw palette.
                  backgroundColor: getPaletteAsRawColors().neutralLighterAlt,
              };

        return (
            <div
                ref={containerRef}
                className={classNames(styles.composeBottomContainer, {
                    isInlineCompose: isInlineCompose,
                    sticky: useStickyDocking,
                    isHidden: !useStickyDocking && isHidden,
                })}>
                {isFeatureEnabled('doc-attachment-recentAttachmentPills') && (
                    <LazyRecentAttachmentPillContainer
                        composeId={viewState.composeId}
                        itemId={viewState.itemId}
                        attachmentWell={viewState.attachmentWell}
                        infoBar={viewState}
                        mailboxInfo={getMailboxInfoFromViewState(viewState)}
                    />
                )}
                {getEditorSupport(viewState).formattingRibbon && isRibbonShown && (
                    <LazyComposeRibbon
                        className={styles.ribbonRow}
                        editorViewState={viewState}
                        viewState={ribbon}
                        insertLinksHost={viewState}
                        fromAddress={getCurrentFromAddress(viewState.toRecipientWell)}
                        skipInitialResize={true}
                        focusToButtonBeforeDropDown={true}
                        isRtl={getUserConfiguration().SessionSettings.IsUserCultureRightToLeft}
                        isDarkMode={isDarkMode}
                        isDisabled={disabled}
                    />
                )}
                <ComposeBottomEditorSendHost viewState={viewState}>
                    <ComposeBottomSendDiscard
                        ref={sendDiscard}
                        viewState={viewState}
                        composeId={viewState.composeId}
                        onSend={sendMessage}
                        onDiscard={discardDraft}>
                        {/* Make the bottom bar conditional on editor support */}
                        {getEditorSupport(viewState).bottomActionBar ? (
                            <ComposeBottomActionBar ref={actionBar} {...commandBarProps} />
                        ) : null}
                    </ComposeBottomSendDiscard>
                </ComposeBottomEditorSendHost>
                {useStickyDocking && !isInlineCompose && (
                    <div className={styles.stickyBottomFiller} style={bottomDockingStyle} />
                )}
                <AttachmentLocalComputerFilePicker
                    ref={attachmentInlineFilePicker}
                    fileSelectionFilter={FileSelectionFilter.Images}
                    action={FilePickerAction.Insert}
                    createAttachmentHandler={createAttachmentHandler}
                />
                <AttachmentLocalComputerFilePicker
                    ref={attachmentLocalComputerFilePicker}
                    fileSelectionFilter={FileSelectionFilter.None}
                    action={FilePickerAction.Attach}
                    createAttachmentHandler={handlerForAttachFromComputer}
                />
                <AttachmentLocalComputerFilePicker
                    ref={attachmentLocalComputerToCloudFilePicker}
                    fileSelectionFilter={FileSelectionFilter.None}
                    action={FilePickerAction.Attach}
                    createAttachmentHandler={handlerForUploadAndShareFromCloud}
                />
            </div>
        );
    },
    { forwardRef: true }
);

function logCSAUserAction(action: ComposeActionKey, item: SurfaceActionItem, suffix: string = '') {
    logUserAction(true /* isCompose */, `${action}${suffix}`, item);
}
